const BASE_URL = process.env.REACT_APP_BASE_URL;

const config = {
  logo: process.env.REACT_APP_LOGO || "https://www.karishye.co/logo.png",
  razorpayUrl:
    process.env.REACT_APP_RAZORPAY_URL ||
    "https://checkout.razorpay.com/v1/checkout.js",
  // Encode URLs for use in routes
  encodedLogo: encodeURIComponent(
    process.env.REACT_APP_LOGO || "https://www.karishye.co/logo.png"
  ),
  encodedRazorpayUrl: encodeURIComponent(
    process.env.REACT_APP_RAZORPAY_URL ||
      "https://checkout.razorpay.com/v1/checkout.js"
  ),
};

export { BASE_URL };
export default config;
